import config from 'config';
import axios from 'helpers/axios';

//ATS joyride docs @ https://wiki.poslovi.live/en/ats/joyride

const verifyCheckpointRequest = ({ section, contentId }) => {
  const formData = new FormData();
  formData.append('section', section);
  formData.append('contentId', contentId);
  formData.append('option', 'project');
  return axios({
    method: 'post',
    url: `${config.apiUrl}/checkOnboarding`,
    data: formData,
  });
};

/**
 * `step` is the step the user was just shown, not the next one — the backend stores it and hands
 * back `step + 1` as `nextStep` on the following /checkOnboarding. Leave it out to close the
 * section for good, which is what every single-shot tour does.
 */
const finishOnboardingRequest = ({ section, step = null, skipLog = false }) => {
  const formData = new FormData();
  formData.append('section', section);
  if (step !== null) {
    formData.append('step', String(step));
  }
  if (skipLog) {
    formData.append('skipLog', 'true');
  }
  return axios({
    method: 'post',
    url: `${config.apiUrl}/finishOnboarding`,
    data: formData,
  });
};

export default verifyCheckpointRequest;
export { finishOnboardingRequest };
